module.exports = __webpack_public_path__ + "img/medal10.c793e5c4.png";